import { render, staticRenderFns } from "./process5.vue?vue&type=template&id=753c3c67&scoped=true&"
import script from "./process5.vue?vue&type=script&lang=js&"
export * from "./process5.vue?vue&type=script&lang=js&"
import style0 from "./process5.vue?vue&type=style&index=0&id=753c3c67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753c3c67",
  null
  
)

export default component.exports